export default __webpack_public_path__ + "static/media/confirmplan.89f5a9a6.svg";